export const API = process.env.REACT_APP_BACKEND_URL;
const BASE = `${API}/api/admin/shop`;
const hdr = () => ({ 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('token')}` });

const req = async (path, method = 'GET', body) => {
  const r = await fetch(`${BASE}${path}`, { method, headers: hdr(), body: body ? JSON.stringify(body) : undefined });
  const data = await r.json().catch(() => ({}));
  if (r.status === 401) {
    localStorage.removeItem('token'); localStorage.removeItem('user');
    sessionStorage.setItem('login_notice', 'Your session expired. Please log in again.');
    window.location.href = '/login?next=/admin';
    return new Promise(() => {});
  }
  if (!r.ok) throw new Error(data.detail || `Request failed (${r.status})`);
  return data;
};
const qs = (o) => new URLSearchParams(Object.entries(o).filter(([, v]) => v)).toString();

export const api = {
  dashboard: () => req('/dashboard'),
  stuck: () => req('/payments/stuck'),
  orders: (f) => req(`/orders?${qs(f)}`),
  order: (id) => req(`/orders/${id}`),
  verifyPayment: (id) => req(`/orders/${id}/verify-payment`, 'POST'),
  markPaid: (id, payment_id, note) => req(`/orders/${id}/mark-paid`, 'POST', { payment_id, note }),
  refund: (id, body) => req(`/orders/${id}/refund`, 'POST', body),
  setStatus: (id, body) => req(`/orders/${id}/status`, 'PUT', body),
  addNote: (id, text) => req(`/orders/${id}/notes`, 'POST', { text }),
  resendEmail: (id, kind) => req(`/orders/${id}/resend-email`, 'POST', { kind }),
  exportCsv: async (f) => {
    const r = await fetch(`${BASE}/orders/export.csv?${qs(f)}`, { headers: hdr() });
    if (!r.ok) throw new Error('Export failed');
    const url = URL.createObjectURL(await r.blob());
    const a = document.createElement('a');
    a.href = url; a.download = `orders-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
    URL.revokeObjectURL(url);
  },
  customers: (q) => req(`/customers?${qs({ q })}`),
  products: () => req('/products?limit=500'),
  saveProduct: (slug, body) => req(`/products${slug ? `/${slug}` : ''}`, slug ? 'PUT' : 'POST', body),
  deleteProduct: (slug) => req(`/products/${slug}`, 'DELETE'),
  duplicate: (slug) => req(`/products/${slug}/duplicate`, 'POST'),
  setStock: (slug, in_stock) => req(`/products/${slug}/stock`, 'PATCH', { in_stock }),
  setVisibility: (slug, published) => req(`/products/${slug}/visibility`, 'PATCH', { published }),
  bulk: (slugs, action) => req('/products/bulk', 'POST', { slugs, action }),
  upload: async (file) => {
    const fd = new FormData(); fd.append('file', file);
    const r = await fetch(`${BASE}/upload`, { method: 'POST', body: fd, headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
    return r.json();
  },
  discounts: () => req('/discounts'),
  saveDiscount: (body) => req('/discounts', 'POST', body),
  delDiscount: (code) => req(`/discounts/${code}`, 'DELETE'),
};

export const STATUS = {
  pending_payment: { label: 'Payment Pending', cls: 'bg-[#FEF3C7] text-[#92400E]' },
  confirmed: { label: 'New · In Queue', cls: 'bg-[#DBEAFE] text-[#1E40AF]' },
  processing: { label: 'New · In Queue', cls: 'bg-[#DBEAFE] text-[#1E40AF]' },
  packed: { label: 'Packed', cls: 'bg-[#EDE9FE] text-[#5B21B6]' },
  shipped: { label: 'Shipped · On the Way', cls: 'bg-[#E0F2FE] text-[#0369A1]' },
  delivered: { label: 'Delivered', cls: 'bg-[#DCFCE7] text-[#166534]' },
  cancelled: { label: 'Cancelled', cls: 'bg-[#F3F4F6] text-[#374151]' },
  refunded: { label: 'Refunded', cls: 'bg-[#FEE2E2] text-[#991B1B]' },
};

export const StatusPill = ({ s, testid }) => {
  const m = STATUS[s] || { label: s, cls: 'bg-gray-100' };
  return <span className={`inline-block px-2 py-0.5 rounded text-xs font-bold whitespace-nowrap ${m.cls}`} data-testid={testid}>{m.label}</span>;
};

export const inr = (v) => `₹${Number(v || 0).toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
export const dt = (s) => (s ? new Date(s.endsWith('Z') || s.includes('+') ? s : `${s}Z`).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' }) : '');
